import { defineMessages } from "react-intl";

export const messages = defineMessages({
  back: {
    id: '27Xygf',
    defaultMessage: "Back",
    description: "wizard step back button",
  },
  skipForNow: {
    id: 'PfbRmu',
    defaultMessage: "Skip for now",
    description: "wizard step skip button",
  },
  finishSetup: {
    id: 'mtFZr4',
    defaultMessage: "Finish Setup",
    description: "wizard last step submit button",
  },
  saveAndContinue: {
    id: 'rQW0Ww',
    defaultMessage: "Save & Continue",
    description: "wizard step next button",
  },
  stepOf: {
    id: 'wEp6F6',
    defaultMessage: "Step {current} of {total}",
    description: "wizard step counter label",
  },
  magicReset: {
    id: '9FCfmX',
    defaultMessage: "Magic Reset",
    description: "button to clear wizard progress from graphql and restart",
  },
});
